import { runbookStepService } from "../services/runbookStep.service";
import { runbookStepConstants } from "../constants/runbookStep.constants";

export const runbookStepActions = {
  get,
  addBlank,
  addForLoopEndLoop,
  addAfter,
  addBefore,
  addTrue,
  addFalse,
  update,
  remove,
  getAllActions,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookStepService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookStepConstants.GET_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return { type: runbookStepConstants.GET_SUCCESS, payload: paginatedResult };
  }
  function failure() {
    return { type: runbookStepConstants.GET_FAILURE };
  }
}

function addBlank(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.addBlank(requestParameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.ADD_BLANK_REQUEST,
    };
  }
  function failure(error) {
    return { type: runbookStepConstants.ADD_BLANK_FAILURE, message: error };
  }
}

function addForLoopEndLoop(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.addForLoopEndLoop(requestParameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.ADD_FORLOOPENDLOOP_REQUEST,
    };
  }
  function failure(error) {
    return {
      type: runbookStepConstants.ADD_FORLOOPENDLOOP_FAILURE,
      message: error,
    };
  }
}

function addAfter(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.addAfter(requestParameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.ADD_AFTER_REQUEST,
    };
  }
  function failure(error) {
    return {
      type: runbookStepConstants.ADD_AFTER_FAILURE,
      message: error,
    };
  }
}

function addBefore(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.addBefore(requestParameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.ADD_BEFORE_REQUEST,
    };
  }
  function failure(error) {
    return {
      type: runbookStepConstants.ADD_BEFORE_FAILURE,
      message: error,
    };
  }
}

function addTrue(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.addTrue(requestParameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.ADD_TRUE_REQUEST,
    };
  }
  function failure(error) {
    return {
      type: runbookStepConstants.ADD_TRUE_FAILURE,
      message: error,
    };
  }
}

function addFalse(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.addFalse(requestParameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.ADD_FALSE_REQUEST,
    };
  }
  function failure(error) {
    return {
      type: runbookStepConstants.ADD_FALSE_FAILURE,
      message: error,
    };
  }
}

function update(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.update(requestParameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.UPDATE_REQUEST,
    };
  }
  function failure(error) {
    return { type: runbookStepConstants.UPDATE_FAILURE, message: error };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.remove(requestParameters).then(
      () => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.DELETE_REQUEST,
    };
  }
  function failure(error) {
    return { type: runbookStepConstants.DELETE_FAILURE, message: error };
  }
}

function getAllActions() {
  return (dispatch) => {
    dispatch(request());

    runbookStepService.getAllActions().then(
      (respose) => {
        dispatch(success(respose.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return {
      type: runbookStepConstants.GET_ALL_ACTIONS_REQUEST,
    };
  }
  function success(data) {
    return {
      type: runbookStepConstants.GET_ALL_ACTIONS_SUCCESS,
      payload: data,
    };
  }
  function failure(error) {
    return {
      type: runbookStepConstants.GET_ALL_ACTIONS_FAILURE,
      message: error,
    };
  }
}
